//TODO: DONE: add firebase configuration and export it

export const firebaseConfig = {
  apiKey: "AIzaSyB7ejFI5tEOXyOK9m34tJAwMXyQ2h5t-cE",
  authDomain: "mygitapp-552bb.firebaseapp.com",
  databaseURL: "https://mygitapp-552bb.firebaseio.com",
  projectId: "mygitapp-552bb",
  storageBucket: "mygitapp-552bb.appspot.com",
  messagingSenderId: "37517798359",
  appId: "1:37517798359:web:cd7ffbc67e530658d93992",
  measurementId: "G-8SPY2D0BYE"
};
//image configuration
export const imageConfig = {
  quality: 0.2,
  maxWidth: 800,
  maxHeight: 600,
  autoRotate: true
};
